import React, { useState } from 'react';
import { Tooltip } from './Tooltip';
import { Button } from '../Button/Button';
import * as PopperJS from 'popper.js';

export function TooltipExample(): JSX.Element {
  const [position, setPosition] = useState<PopperJS.Placement>('bottom');
  return (
    <div>
      <header style={{ marginBottom: '20px' }}>
        <label>Position</label>
        <select value={position} onChange={(e) => setPosition(e.target.value as PopperJS.Placement)}>
          <option value="bottom">bottom</option>
          <option value="right">right</option>
          <option value="right-start">right top</option>
          <option value="right-end">right bottom</option>
          <option value="left">left</option>
          <option value="left-start">left top</option>
          <option value="left-end">left bottom</option>
          <option value="top">top</option>
          <option value="top-start">top left</option>
          <option value="top-end">top right</option>
          <option value="bottom-end">bottom right</option>
          <option value="bottom-start">bottom left</option>
        </select>
      </header>
      <Tooltip position={position} reference={<Button title="Open tooltip" />}>
        <div style={{ width: '300px' }}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta suscipit quibusdam culpa? Quas hic
          exercitationem officia, architecto expedita ipsa perspiciatis asperiores, vitae nobis quo quod, tempore
          pariatur assumenda cupiditate itaque.
        </div>
      </Tooltip>
    </div>
  );
}
